module.exports = __webpack_public_path__ + "images/f06e343f6a1d6f8afa57c1779888c0e2.png";